// ============================================================================
// Shared AG Grid setup for the QS / BOQ workspace
// ============================================================================
// One-time module registration + the BRIO-flavoured Quartz theme, shared by
// every grid in the QS app (Project Items, Rates, …) so they look identical and
// stay aligned with the BRIO Design System: white canvas, grey-light headers,
// hairline borders, gold accent, Raleway. Importing this module registers the
// community modules as a side effect (AG Grid v33+ requires registration before
// any grid renders).
// ============================================================================

import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

// Mapped to BRIO tokens (see src/styles/brio-styles.css): gold #9F902A accent,
// grey-light (#f5f5f5) header, rgba(0,0,0,0.1) hairline, dark ink text.
export const brioGridTheme = themeQuartz.withParams({
  accentColor: '#9F902A',
  fontFamily: 'Raleway, sans-serif',
  fontSize: 12,
  foregroundColor: '#222222',
  backgroundColor: '#ffffff',
  headerBackgroundColor: '#fafaf8',          // matches the Team Overview header
  headerTextColor: '#666666',
  headerFontWeight: 600,
  borderColor: '#e5e5e5',
  rowHoverColor: '#fafaf4',                   // matches the Team Overview row hover
  selectedRowBackgroundColor: '#f0e9c2',
  rangeSelectionBorderColor: '#9F902A',
  rangeSelectionBackgroundColor: '#9F902A26',
  wrapperBorderRadius: 0,
  headerColumnResizeHandleColor: 'transparent',   // no heavy gold separators
});

export default brioGridTheme;
